export class TableModel {
  tableId: number;
  tableName: string;
  nameGroup: string;
  tableCategoryId: number;
  num: number;
  time: string;
  waiterId?: number;
  waiterName: string;
  customerName: string;
  phoneNumber: string;
  guestQty: number;
  branchCode: number;
  isTas: number;
  fireLevel: number;
  printAsh: number;
  hasCashPrint: number;
  isOrderPrint?: number;
}
